/** Viewport-width fraction to expand to; ≥ 0.5 clamps to the panel's 50% cap. */
export const SPLIT_LAYOUT_EXPAND_FRACTION = 0.51;

/** Width (px) to collapse back to when no previous width was remembered. */
export const DEFAULT_COLLAPSED_PANEL_WIDTH = 400;
